import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'scan-pickups' });

export const { find, create, get, patch, reducer, remove, update } = actions;

export default reducer;
